import { Box, Button, Stack, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import React from "react";

const AboutUsSectionMain = () => {
  // Content paragraphs data
  const paragraphs = [
    "Apna Card is a seamless digital solution for instant connections. Share your contact details with a tap using NFC or let others scan your QR code—no more paper exchanges.",
    "Apna Card goes beyond contact sharing. Capture leads, track interactions, and integrate with your CRM to nurture your network and grow your business. Export data to Excel or CSV, identify potential clients, and make smarter marketing decisions.",
  ];

  return (
    <>
      <Box
        component="section"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        py={{ xs: 6, md: 8 }} // 50px -> 96px
        px={{ xs: 2.5, sm: 4, md: 12.5 }} // responsive horizontal padding
        bgcolor="background.paper"
        gap={{ xs: 4, md: 6 }}
      >
        <Stack
          spacing={{ xs: 2.5, md: 3.125 }}
          width={{ xs: "100%", md: "50%" }}
          maxWidth={{ xs: "640px", md: "100%" }}
          textAlign={{ xs: "center", md: "left" }}
          mx="auto"
        >
          <Typography
            variant="h2"
            color="primary.main"
            sx={{
              fontFamily: "'Jost-Bold', Montserrat",
              fontSize: { xs: 36, sm: 42, md: 64 },
              fontWeight: 700,
              letterSpacing: { xs: "-2px", md: "-3.84px" },
            }}
          >
            WHO WE ARE
          </Typography>

          <Stack spacing={2.5}>
            {paragraphs.map((paragraph, index) => (
              <Typography
                key={index}
                variant="body1"
                color="text.primary"
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  lineHeight: 1.7,
                }}
              >
                {paragraph}
              </Typography>
            ))}
          </Stack>

          <Button
            variant="contained"
            color="primary"
            sx={{
              width: { xs: "100%", sm: "fit-content" },
              minWidth: { xs: "100%", sm: 220 },
              height: { xs: 48, md: 55 },
              borderRadius: "10px",
              textTransform: "none",
            }}
            endIcon={<ArrowOutwardIcon />}
          >
            Contact Us
          </Button>
        </Stack>

        <Box
          component="img"
          src={"/websiteAssets/AboutUsWhoWeAre.png"} // Replace with the actual image path
          alt="Team members"
          sx={{
            width: { xs: "100%", sm: "80%", md: "45%" },
            maxWidth: { xs: 520, md: 615 },
            height: "auto",
            maxHeight: { xs: 340, md: 420 },
            objectFit: "cover",
            borderRadius: { xs: "18px", md: "24px" },
            mx: "auto",
          }}
        />
      </Box>
    </>
  );
};

export default AboutUsSectionMain;
